import styles from '../InformationsForms/InformationFormsStyle.module.scss';
import { useContext } from "react";
import { mainContext } from "../../context/context";
import { Col, Form, Input, Row } from "antd"
import { formatPhoneNumber } from '../../utils/helpers/phoneFormatter';


const ContactsFields = ({ onChange, formValues, disabled, errors, isFax, isHomePhone, isCellPhone, isEmail, isWorkPhone, isExt, isLabel, isCariskCICPayerId }) => {
    const { activeTab } = useContext(mainContext);

    const fieldSettings = {
        email: { label: ["Email", null, "Main Number", "Phone"], placeholder: ["Email", null, "Main Number", "Phone"] , validateStatus : errors?.email ? 'error' : '', help:errors?.email, required:true},
        phone1: { label: ["Home Phone", null, "Main Number", "Phone"], placeholder: ["Home Phone", null, "Main Number", "Phone"], validateStatus : errors?.phone1 ? 'error' : '', help:errors?.phone1, required:true },
        mobile: { label: ["Cell Phone", null, "Ext.", "Ext."], placeholder: ["Cell Phone", null, "Ext.", "Ext."] , validateStatus : errors?.mobile ? 'error' : '', help:errors?.mobile, required:true},
        phone3: { label: ["Work Phone", null, "Fax", "Fax"], placeholder: ["Work Phone", null, "Fax", "Fax"],validateStatus : errors?.phone3 ? 'error' : '', help:errors?.phone3, required:false  },
        phone4: { label: ["Ext.", null, "Cell Phone", "Email"], placeholder: ["Ext.", null, "Cell Phone", "Email"], validateStatus : errors?.phone4 ? 'error' : '', help:errors?.phone4, required:false  },
        fax: { label: ["Fax", null, "Cell Phone", "Email"], placeholder: ["Fax", null, "Cell Phone", "Email"],validateStatus : errors?.fax ? 'error' : '', help:errors?.fax, required:true  },
        cariskCICPayerId: { label: ["Carisk CIC Payer Id", null, "Carisk CIC Payer Id", "Carisk CIC Payer Id"], placeholder: ["Carisk CIC Payer Id", null, "Carisk CIC Payer Id", "Carisk CIC Payer Id"], validateStatus : errors?.cariskCICPayerId ? 'error' : '', help:errors?.cariskCICPayerId, required:true  },
    };

    const handlePhoneChange = (e) => {
        const phoneFields = ['phone1', 'mobile', 'phone3', 'phone4', 'alternatePhone', 'fax', 'phone'];
        if (phoneFields.includes(e.target.name)) {
            const formattedEvent = formatPhoneNumber(e);
            onChange(formattedEvent);
        } else {
            onChange(e);
        }
    };

    const renderField = (name, visible) => {
        if (!visible) return null;
        const { label, placeholder, validateStatus, help, required } = fieldSettings[name];
        
        return (
            <Col xs={24} md={6} lg={6} key={name}>
                <Form.Item 
                    layout="vertical" 
                    label={`${label[activeTab]}`} 
                    htmlFor={name} 
                    validateStatus={validateStatus} 
                    help={help} 
                    required={required}
                >
                    <Input 
                        size="large"  
                        fullWidth 
                        placeholder={placeholder[activeTab]} 
                        name={name} 
                        id={name} 
                        disabled={disabled} 
                        onChange={name === 'email' ? onChange : handlePhoneChange}
                        value={formValues?.[name] || ""}
                        maxLength={name === 'email' ? undefined : 12}
                    />
                </Form.Item>
            </Col>
        );
    };

    return (
        <div className={styles.formContainer}>
          <Row gutter={16} className={styles.gridContainer}>
                {renderField("email", isEmail)}
                {renderField("phone1", isHomePhone)}
                {renderField("mobile", isCellPhone)}
                {renderField("phone3", isWorkPhone)}
                {renderField("phone4", isExt)}
                {renderField("fax", isFax)}
            </Row>
            {isLabel && (
                <div className={styles.contactWrapper}><div className={styles.header}><h4>Main Contact Person</h4></div>
                     <Row gutter={16} className={styles.gridContainer}>
                     <Col xs={24} lg={12} >
                            <Form.Item className={styles.inpuLabels}  layout="vertical" label="Name">
                                <Input size="large" fullWidth placeholder="Name" name="name" id="name" disabled={disabled} onChange={onChange} value={formValues?.name || ""} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12} >
                            <Form.Item className={styles.inpuLabels}  layout="vertical" label="Phone">
                                <Input size="large" fullWidth placeholder="Phone" name="phone" id="phone" disabled={disabled} onChange={handlePhoneChange} value={formValues?.phone || ""} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item className={styles.inpuLabels}  layout="vertical" label="Email">
                                <Input size="large" fullWidth placeholder="Email" name="personEmail" id="email" disabled={disabled} onChange={onChange} value={formValues?.personEmail || ""} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} lg={12}>
                            <Form.Item className={styles.inpuLabels}  layout="vertical" label="Carisk CIC Payer Id">
                                <Input size="large" fullWidth placeholder="Carisk CIC Payer Id" name="cariskCICPayerId" id="cariskCICPayerId" disabled={disabled} onChange={onChange} value={formValues?.cariskCICPayerId || ""} />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
};

export default ContactsFields;